import { Button, Drawer, Form, Input, message } from 'antd';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import React, { useEffect } from 'react';
import { KBKService } from 'services/KBKService';
import { requiredRule } from 'utils/forms/validationRules';

function KBKForm({ isActive, onClose, onSuccess, initialValues }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { code, name } = initialValues;

      form.setFieldsValue({
        name,
        code,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      handleUpdate(values, initialValues.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await KBKService.createKBK(data);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await KBKService.updateKBK(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование КБК' : 'Создание КБК'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="code" label="Код" rules={[requiredRule]}>
          <Input placeholder="Введите код" allowClear />
        </Form.Item>

        <Form.Item name="name" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Наименование КБК" allowClear />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { KBKForm };
